var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container"},[_c('ul',[_c('li',[_c('span',[_vm._v(_vm._s(_vm.$t('contentFooter.poweredByExtremeDigitalSolutions'))+" © "+_vm._s(new Date().getFullYear()))])])])])])}
var staticRenderFns = []

export { render, staticRenderFns }